import { render, staticRenderFns } from "./ProjectPageActions.vue?vue&type=template&id=b57d43c0&scoped=true&"
import script from "./ProjectPageActions.vue?vue&type=script&lang=js&"
export * from "./ProjectPageActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57d43c0",
  null
  
)

export default component.exports